import { Controller } from "@hotwired/stimulus";

export default class ModulePrinterController extends Controller {
  static targets = ["printSection"];

  print() {
    this.printSectionTargets.forEach(t => t.classList.remove("hidden"));
    window.print();
    this.printSectionTargets.forEach(t => t.classList.add("hidden"))
  }
}
